/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryResponse,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsPathParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods401,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods500,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods } from "../../clients/individualPaymentLookupsController/getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods.ts";

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryKey =
  (
    courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsPathParams["courseFinancialId"],
    params?: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryParams,
  ) =>
    [
      {
        url: "/api/v1/individualpayment/course-financials/:courseFinancialId/available-payment-methods",
        params: { courseFinancialId: courseFinancialId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryKey
  >;

export function getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryOptions(
  courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsPathParams["courseFinancialId"],
  params?: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryKey(
      courseFinancialId,
      params,
    );
  return queryOptions<
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods401
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods500
    >,
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseFinancialId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods(
        courseFinancialId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Migrado do legado IndividualPayment/GetAvailablePaymentMethodsByCourse. **(Requer Authorization para autenticação)**
 * @summary Métodos de pagamento disponíveis no plano do curso (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/course-financials/:courseFinancialId/available-payment-methods}
 */
export function useGetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods<
  TData =
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryKey,
>(
  courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsPathParams["courseFinancialId"],
  params?: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods401
          | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryKey(
      courseFinancialId,
      params,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryOptions(
        courseFinancialId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods401
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
